import store from "@/store";

// Remove all logic except authentication check
export function beforeRouteEnter(to, from, next) {
  const currentUser = store.getters["auth/currentUserSafe"];
  if (!currentUser || currentUser.id === null) {
    next("/login");
    return;
  }
  next();
}
